module.exports = __webpack_public_path__ + "img/Flag_of_Iraq.711f016f.svg";